import React from 'react';
import PropTypes from 'prop-types';
import EmptyState from '../../../../components/EmptyState/EmptyState';
import {
  Section,
  SectionTitle,
  HighlightsGrid,
  HighlightsColumn,
  HighlightsList,
  HighlightItem,
  HighlightTitle,
  HighlightSubtitle,
  HighlightBody,
} from './TyreTechnical.style';

const TyreTechnical = ({technicalHighlightsB2C, technicalHighlightsB2B, t}) => {
  const hasContent =
    technicalHighlightsB2C?.length > 0 || technicalHighlightsB2B?.length > 0;

  // Parse highlight text into structured data
  const parseHighlight = (text) => {
    if (!text) return null;
    
    const lines = text.split('\n').filter(line => line.trim());
    if (lines.length === 0) return null;
    
    // First line with colon is the title
    const titleLine = lines[0];
    const hasColon = titleLine.includes(':');
    
    if (hasColon) {
      const [title, ...rest] = titleLine.split(':');
      const remainingLines = rest.join(':').trim() ? [rest.join(':').trim(), ...lines.slice(1)] : lines.slice(1);
      
      // Second line (if exists and short) might be subtitle
      const subtitle = remainingLines.length > 0 && remainingLines[0].length < 60 
        ? remainingLines[0] 
        : null;
      
      const bodyStart = subtitle ? 1 : 0;
      const body = remainingLines.slice(bodyStart).join(' ').trim();
      
      return {
        title: title.trim(),
        subtitle,
        body: body || null,
      };
    }
    
    // No colon pattern, just return as body text
    return {
      title: null,
      subtitle: null,
      body: text,
    };
  };

  if (!hasContent) {
    return (
      <Section>
        <SectionTitle>Tehnični poudarki</SectionTitle>
        <EmptyState
          icon="mdi-cog-outline"
          title="Ni tehničnih poudarkov"
          description="Tehnične informacije za ta izdelek niso na voljo"
        />
      </Section>
    );
  }

  const hasHighlights =
    technicalHighlightsB2C?.length > 0 || technicalHighlightsB2B?.length > 0;

  return (
    <Section>
      <SectionTitle>Tehnični poudarki</SectionTitle>

      {hasHighlights && (
        <HighlightsGrid>
          {technicalHighlightsB2C && technicalHighlightsB2C.length > 0 && (
            <HighlightsColumn>
              <HighlightsList>
                {technicalHighlightsB2C.map((highlight, index) => {
                  const parsed = parseHighlight(highlight);
                  if (!parsed) return null;
                  
                  return (
                    <HighlightItem key={index} index={index}>
                      <i className="mdi mdi-chevron-right-circle" />
                      <div>
                        {parsed.title && <HighlightTitle>{parsed.title}</HighlightTitle>}
                        {parsed.subtitle && <HighlightSubtitle>{parsed.subtitle}</HighlightSubtitle>}
                        {parsed.body && <HighlightBody>{parsed.body}</HighlightBody>}
                      </div>
                    </HighlightItem>
                  );
                })}
              </HighlightsList>
            </HighlightsColumn>
          )}

          {technicalHighlightsB2B && technicalHighlightsB2B.length > 0 && (
            <HighlightsColumn>
              <HighlightsList>
                {technicalHighlightsB2B.map((highlight, index) => {
                  const parsed = parseHighlight(highlight);
                  if (!parsed) return null;
                  
                  return (
                    <HighlightItem key={index} index={index}>
                      <i className="mdi mdi-chevron-right-circle" />
                      <div>
                        {parsed.title && <HighlightTitle>{parsed.title}</HighlightTitle>}
                        {parsed.subtitle && <HighlightSubtitle>{parsed.subtitle}</HighlightSubtitle>}
                        {parsed.body && <HighlightBody>{parsed.body}</HighlightBody>}
                      </div>
                    </HighlightItem>
                  );
                })}
              </HighlightsList>
            </HighlightsColumn>
          )}
        </HighlightsGrid>
      )}
    </Section>
  );
};

TyreTechnical.propTypes = {
  technicalHighlightsB2C: PropTypes.array,
  technicalHighlightsB2B: PropTypes.array,
};

export default TyreTechnical;
